import { useBrowserLocation } from '@vueuse/core';

/**
 * Build-time switch for the merchant-area entry points (dashboard tile, merchant card on account creation), so this
 * app can ship before merchant-area is deployed. Read at call time so tests can stub it.
 */
export const isMerchantAreaEnabled = (): boolean => import.meta.env.VITE_MERCHANT_AREA_ENABLED === 'true';

/**
 * Merchant-area's signup page, on the sibling host of the current one (account.<domain> → merchant.<domain>),
 * built like the dashboard's merchant-area tile so it needs no extra env var.
 */
export const getMerchantSignupUrl = (): string => {
	const url = new URL(useBrowserLocation().value.href || window.location.href);
	return `${url.protocol}//${url.hostname.replace('account', 'merchant')}/signup`;
};
